export const RupeesToPaiseConversion = (amount: number) => {
  const amount_ = amount*100;
  return amount_;
}

export const PaiseToRupeesConversion = (amount: number) => {
  const amount_ = amount/100;
  return amount_;
}

/*
 * Converts an amount from paisa to a formatted string in Rupees with Indian comma separation.
 * The Indian numbering system uses commas after the first three digits from the right, and then every two digits.
 *
 * @param amountInPaisa The amount in paisa (number).
 * @returns A formatted string with the '₹' symbol and commas.
*/

export const formatCurrencyIndian = (amountInPaisa: number): string => {
  // Convert paisa to rupees by dividing by 100
  const amountInRupees = (amountInPaisa / 100).toFixed(2);

  // Split the number into integer and decimal parts
  const [integerPart, decimalPart] = amountInRupees.split('.');

  // Use a regular expression to add commas in the Indian style
  const lastThree = integerPart.substring(integerPart.length - 3);
  const otherNumbers = integerPart.substring(0, integerPart.length - 3);

  // If there are more than 3 digits, apply the comma separation
  const formattedInteger = (otherNumbers.length !== 0) ?
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + ',' + lastThree :
    lastThree;

  // Combine the symbol, integer part, and decimal part
  return `₹ ${formattedInteger}.${decimalPart}`;
};